import React, { useRef } from 'react'
import { useTableComponentStyle } from 'UI/Table/style'
import { IColumn } from 'typescript/interfaces/tableUi'
import { IChangeLogListItem } from 'typescript/interfaces/changeLog'
import TableComponent, { TableComponentType } from 'UI/Table'
import { convertDate } from 'utils/formatters'
import IconButton from '@material-ui/core/IconButton'
import { ReactComponent as DeleteIcon } from 'assets/svg/DeleteTrashIcon.svg'
import { ReactComponent as EditIcon } from 'assets/svg/EditIcon.svg'

export const TableChangeLogEntries = TableComponent as TableComponentType<IChangeLogListItem>

interface IUseChangeLogEntriesProps {
  handleEdit?: (entry: IChangeLogListItem) => void
  handleDelete?: (entry: IChangeLogListItem) => void
}

export const useChangeLogEntries: (props?: IUseChangeLogEntriesProps) => any = (props = {}) => {
  const { handleEdit, handleDelete } = props
  const classes = useTableComponentStyle()
  const columns = useRef<Array<IColumn<IChangeLogListItem>>>([
    {
      label: 'Name',
      field: 'name',
      bodyCellClassName: classes.secondaryBodyCell,
    },
    {
      label: 'Release Date',
      field: 'releaseDate',
      bodyCellClassName: classes.secondaryBodyCell,
      render: (data) => convertDate(data.releaseDate),
    },
    {
      label: 'Shown To',
      field: 'enabledRoles',
      bodyCellClassName: classes.secondaryBodyCell,
      render: (data) => (data.enabledRoles.length ? data.enabledRoles.join(', ') : '—'),
    },
    {
      label: 'Last Updated',
      field: 'updatedDate',
      bodyCellClassName: classes.secondaryBodyCell,
      render: (data) => convertDate(data.updatedDate),
    },
    {
      field: 'actions',
      label: '',
      cellStyle: {
        width: 110,
      },
      render: (data) => {
        return (
          <>
            <IconButton size="small" onClick={() => handleEdit?.(data)}>
              <EditIcon />
            </IconButton>
            <IconButton size="small" onClick={() => handleDelete?.(data)}>
              <DeleteIcon />
            </IconButton>
          </>
        )
      },
    },
  ])

  return {
    columns: columns.current,
  }
}
